var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import * as React from 'react';
import { Modal, Snackbar, Tooltip } from '@cimpress/react-components';
import Spinner from '@cimpress/react-components/lib/shapes/Spinner';
import Checkbox from '@material-ui/core/Checkbox';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import TextArea from '@material-ui/core/TextField';
import { connect } from 'react-redux';
import { initializeState, onBlurCustomInput, onCheckBoxToggle, onClickAttribute, onCustomInputChange, onSubmitCustomBulkExport, onSubmitCustomInput, showAddValueLink, toggleEmailSentStatus } from '../../actions/CustomBulkExportAction';
import { toggleCustomBulkExportModal } from '../../actions/BulkExportAction';
import countries from 'i18n-iso-countries';
import { DialogTitle } from '@material-ui/core';
import { CONSTANTS } from '../../utils/constants';
import { ingestData } from '../../services/cimbaIngestion'; // eslint-disable-next-line @typescript-eslint/no-var-requires

countries.registerLocale(require('i18n-iso-countries/langs/en.json'));

function mapStateToProps(state) {
  return {
    bulkExport: state.bulkExport,
    customBulkExport: state.customBulkExport
  };
}

var mapDispatchToProps = {
  toggleCustomBulkExportModal: toggleCustomBulkExportModal,
  initializeState: initializeState,
  onClickAttribute: onClickAttribute,
  onCheckBoxToggle: onCheckBoxToggle,
  showAddValueLink: showAddValueLink,
  onSubmitCustomInput: onSubmitCustomInput,
  onBlurCustomInput: onBlurCustomInput,
  onCustomInputChange: onCustomInputChange,
  onSubmitCustomBulkExport: onSubmitCustomBulkExport,
  toggleEmailSentStatus: toggleEmailSentStatus
};
var connector = connect(mapStateToProps, mapDispatchToProps);

var CustomBulkExport =
/** @class */
function (_super) {
  __extends(CustomBulkExport, _super);

  function CustomBulkExport() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.getCountryName = function (attributeValue) {
      return countries.getName(attributeValue, 'en') + " (" + attributeValue + ")";
    };

    _this.getListAttributesContainer = function () {
      var _a = _this.props.customBulkExport,
          possibilitiesSet = _a.possibilitiesSet,
          checked = _a.checked,
          openList = _a.openList,
          enabledInputCustomValues = _a.enabledInputCustomValues,
          customInput = _a.customInput;

      if (possibilitiesSet) {
        return Object.keys(possibilitiesSet).map(function (attribute) {
          var attributeInfo = possibilitiesSet[attribute];
          var possibleValues = attributeInfo.possibleValues;
          var countryNames = {};
          var sortedCountries = [];

          if (attribute.toLowerCase() === 'country') {
            possibleValues.forEach(function (value) {
              countryNames[_this.getCountryName(value)] = value;
            });
            possibleValues = [];
            sortedCountries = Object.keys(countryNames).sort();
            sortedCountries.forEach(function (name, index) {
              possibleValues[index] = countryNames[name];
            });
          }

          return React.createElement(React.Fragment, {
            key: attribute
          }, React.createElement(ListItem, {
            key: attribute,
            button: true,
            onClick: function onClick() {
              return _this.props.onClickAttribute(attribute);
            },
            className: "export-list-item"
          }, React.createElement(ListItemText, {
            primary: attribute[0].toUpperCase() + attribute.substring(1),
            className: "checkbox-head"
          }), openList[attribute] ? React.createElement(ExpandLess, null) : React.createElement(ExpandMore, null)), React.createElement(Collapse, {
            in: openList[attribute],
            timeout: "auto",
            unmountOnExit: true,
            className: "collapse-list-item"
          }, React.createElement(List, {
            key: attribute + "-collapsible",
            component: "div",
            disablePadding: true,
            className: "collapsible-attribute-list"
          }, possibleValues.map(function (value, index) {
            return React.createElement(ListItem, {
              key: attribute + "-" + value,
              role: undefined,
              dense: true,
              button: true,
              onClick: function onClick() {
                return _this.props.onCheckBoxToggle(value, attribute);
              },
              className: "list-item-export"
            }, React.createElement(ListItemIcon, null, React.createElement(Checkbox, {
              edge: "start",
              key: attribute + "-" + value,
              checked: checked[attribute] && checked[attribute].indexOf(value) !== -1,
              tabIndex: -1,
              disableRipple: true,
              inputProps: {
                'aria-labelledby': attribute + "-" + value
              },
              className: "export-checkbox"
            })), React.createElement(ListItemText, {
              key: value,
              className: "checkbox-text"
            }, React.createElement("span", {
              style: {
                fontSize: '12px'
              }
            }, " ", attribute.toLowerCase() === 'country' ? sortedCountries[index] : value)), !enabledInputCustomValues[attribute] && attributeInfo.isRange && index === possibleValues.length - 1 && React.createElement("span", null, React.createElement("a", {
              onClick: function onClick(event) {
                event.stopPropagation();

                _this.props.showAddValueLink(attribute);
              }
            }, "Add more")));
          }), attributeInfo.isRange && enabledInputCustomValues[attribute] && React.createElement(ListItem, {
            key: attribute + "-range",
            role: undefined,
            dense: true,
            className: "list-item-export"
          }, React.createElement(ListItemIcon, null, React.createElement(Checkbox, {
            disabled: true,
            className: "disabled-export-checkbox",
            value: "custom",
            color: "default",
            inputProps: {
              'aria-label': 'disabled checkbox'
            }
          })), React.createElement(ListItemText, {
            className: "checkbox-text"
          }, React.createElement("div", null, React.createElement("form", {
            onSubmit: function onSubmit(event) {
              event.preventDefault();

              _this.props.onSubmitCustomInput(attribute);
            }
          }, React.createElement(Tooltip, {
            direction: "right",
            contents: attributeInfo.toolTip,
            className: "honor-newlines"
          }, React.createElement(TextArea, {
            autoFocus: true,
            error: customInput[attribute].style === 'error',
            id: "text-area",
            helperText: customInput[attribute].helpText,
            className: "export-custom-label " + (customInput[attribute].style === 'error' && 'error-custom-input'),
            value: customInput[attribute].value,
            onChange: function onChange(e) {
              return _this.props.onCustomInputChange(e.target.value, attribute);
            },
            margin: "normal",
            onBlur: function onBlur() {
              return _this.props.onBlurCustomInput(attribute);
            }
          })))))))));
        });
      }

      return null;
    };

    return _this;
  }

  CustomBulkExport.prototype.componentDidMount = function () {
    this.props.initializeState();
  };

  CustomBulkExport.prototype.render = function () {
    var _this = this;

    var showCustomBulkExportModal = this.props.bulkExport.showCustomBulkExportModal;
    var _a = this.props.customBulkExport,
        customExportDisabled = _a.customExportDisabled,
        emailSentStatus = _a.emailSentStatus,
        combinationsCount = _a.combinationsCount;
    var listAttributes = this.getListAttributesContainer();
    var submitButton = React.createElement("button", {
      type: "button",
      className: "btn btn-default",
      disabled: customExportDisabled,
      onClick: function onClick() {
        ingestData({
          feature: 'CustomBulkExport'
        });

        _this.props.onSubmitCustomBulkExport();

        _this.props.toggleCustomBulkExportModal(false);
      }
    }, "Submit");
    return React.createElement(React.Fragment, null, React.createElement(Modal, {
      className: "custom-export-modal",
      show: showCustomBulkExportModal,
      onRequestHide: function onRequestHide() {
        return _this.props.toggleCustomBulkExportModal(false);
      },
      title: "Custom Download",
      closeButton: true,
      footer: React.createElement("div", null, customExportDisabled ? React.createElement(DialogTitle, {
        className: "bulk-export-warning"
      }, "Maximum combinations size exceeded. Please narrow down the combinations. ", React.createElement("br", null), "Combinations: ", combinationsCount.toLocaleString(), " (Must be less than", ' ', CONSTANTS.MAXIMUM_COMBINATIONS_COUNT.toLocaleString(), ")") : null, React.createElement("div", {
        style: {
          paddingRight: '6px'
        }
      }, React.createElement("button", {
        type: "button",
        className: "btn btn-default",
        onClick: this.props.initializeState
      }, "Reset"), customExportDisabled ? React.createElement(Tooltip, {
        contents: "Maximum combinations size exceeded. Please narrow down the combinations.",
        direction: "top",
        style: {
          paddingLeft: '5px'
        }
      }, submitButton) : submitButton))
    }, React.createElement("div", {
      className: "container",
      style: {
        width: 'auto'
      }
    }, listAttributes ? listAttributes.length > 0 ? React.createElement("div", {
      className: "row"
    }, React.createElement("h5", {
      style: {
        textAlign: 'center'
      }
    }, React.createElement("span", {
      className: "list-attributes"
    }, "Select Attribute Values")), React.createElement(DialogTitle, {
      style: {
        marginTop: '-15px'
      }
    }, "Tip: If no value is selected for an attribute, all its values are taken for making combination."), React.createElement(List, {
      style: {
        marginTop: '-15px'
      }
    }, listAttributes)) : React.createElement("span", null, "No attributes available") : React.createElement(Spinner, {
      className: "flex-center"
    }))), React.createElement(Snackbar, {
      show: emailSentStatus,
      bsStyle: emailSentStatus,
      delay: 5000,
      onHideSnackbar: function onHideSnackbar() {
        return _this.props.toggleEmailSentStatus(null);
      }
    }, emailSentStatus && emailSentStatus === 'success' && 'A custom bulk export job has been triggered. Once the job is complete, an email will be sent to you with the download link.' || emailSentStatus === 'danger' && 'An error occurred.'));
  };

  return CustomBulkExport;
}(React.Component);

export default connector(CustomBulkExport);